import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { formatAmount, formatEventDate } from "@/lib/format";
import EmptyState from "@/components/EmptyState";
import { Gift, Wallet } from "lucide-react";

const STATUS = {
  active: { label: "Actif", className: "z-badge z-badge-teal" },
  fully_used: { label: "Épuisé", className: "z-badge z-badge-success" },
  expired: { label: "Expiré", className: "z-badge", style: { background: "rgba(161,44,123,0.12)", color: "var(--z-error)" } },
};

export default function MyVouchersPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/me/vouchers").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="z-container" style={{ textAlign: "center" }}><span className="z-loader z-loader-dark" /></div>;

  return (
    <div className="z-container" data-testid="my-vouchers-page">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18, gap: 12, flexWrap: "wrap" }}>
        <div>
          <h1 className="z-page-title">Mes bons d'achat</h1>
          <p className="z-page-sub" style={{ marginBottom: 0 }}>{items.length} bon(s) dans votre portefeuille</p>
        </div>
        <Link to="/voucher-claim" className="z-btn z-btn-outline" data-testid="claim-link">Réclamer un code</Link>
      </div>

      {items.length === 0 ? (
        <EmptyState icon={<Wallet size={28} />} title="Portefeuille vide" message="Réclamez un code pour ajouter un bon." testId="vouchers-empty">
          <Link to="/voucher-claim" className="z-btn z-btn-primary">Saisir un code</Link>
        </EmptyState>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: 14 }}>
          {items.map((v) => {
            const st = STATUS[v.status] || STATUS.active;
            return (
              <Link key={v.id} to={`/voucher/${v.id}`} className="z-card" style={{ padding: 16, textDecoration: "none", color: "inherit" }} data-testid={`my-voucher-${v.id}`}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                  <span className="z-badge z-badge-teal">{v.type === "amount" ? "💰 Montant" : "🎁 Articles"}</span>
                  <span className={st.className} style={st.style || {}}>{st.label}</span>
                </div>
                <h3 style={{ margin: "0 0 4px", fontSize: 16, fontWeight: 700 }}>{v.title}</h3>
                <div style={{ fontSize: 13, color: "var(--z-muted)" }}>par {v.merchant_name}</div>
                {v.type === "amount" ? (
                  <div style={{ marginTop: 10, fontSize: 22, fontWeight: 800, color: "var(--z-teal)" }}>
                    {formatAmount(v.remaining_amount, v.currency)}
                  </div>
                ) : (
                  <div style={{ marginTop: 10, fontSize: 13 }}>
                    {v.items.map((it, i) => (
                      <div key={i} style={{ color: it.used_quantity >= it.quantity ? "var(--z-muted)" : "var(--z-text)", textDecoration: it.used_quantity >= it.quantity ? "line-through" : "none" }}>
                        • {it.label} ({it.quantity - it.used_quantity}/{it.quantity})
                      </div>
                    ))}
                  </div>
                )}
                {v.expires_at && <div style={{ fontSize: 11, color: "var(--z-muted)", marginTop: 8 }}>Expire le {formatEventDate(v.expires_at)}</div>}
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
